import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nonuser',
  templateUrl: './nonuser.component.html',
  styleUrls: ['./nonuser.component.scss']
})
export class NonuserComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
